import React from "react";
import { useFormikContext } from "formik";
import { bool } from "prop-types";

import useReducerActions from "../../utilities/useReducerActions";
import * as S from "./styled";

const answers = [
  { text: "I need to start plans", value: "need_to_start" },
  {
    text: "I’m prequalified",
    tooltip: {
      text:
        "A lender gives you an estimate of what you might be able to borrow. They base it on information you share.",
      title: "Prequalified"
    },
    value: "prequalified"
  },
  {
    text: "I’m preapproved",
    tooltip: {
      text:
        "A lender gives you a conditional loan commitment. They base it on your verified personal and financial information.",
      title: "Preapproved"
    },
    value: "preapproved"
  },
  { text: "I plan to buy in cash", value: "cash" }
];

const renderLabel = answer => (
  <>
    {answer.text}
    {answer.tooltip && (
      <S.Tooltip>
        <b>{answer.tooltip.title}</b>
        <br />
        {answer.tooltip.text}
      </S.Tooltip>
    )}
  </>
);

const FinancingQuestion = ({ isOnLastStep }) => {
  const {
    dispatchSetNextQuestionnaireStep,
    dispatchSetPostSubmitAnswers
  } = useReducerActions();
  const { setFieldError } = useFormikContext();

  const handleAnswerOptionChange = event => {
    setFieldError("form_submission", null);

    dispatchSetPostSubmitAnswers({
      financing_status: event.target.value
    });

    if (!isOnLastStep) {
      dispatchSetNextQuestionnaireStep();
    }
  };

  return (
    <>
      <S.Text>What stage are your plans at for financing a new home?</S.Text>
      <S.Answers>
        {answers.map(answer => (
          <S.AnswerOption
            key={answer.value}
            label={renderLabel(answer)}
            name="financing_question"
            onChange={handleAnswerOptionChange}
            value={answer.value}
          />
        ))}
      </S.Answers>
    </>
  );
};

FinancingQuestion.propTypes = {
  isOnLastStep: bool.isRequired
};

export default FinancingQuestion;
